// routes.js
import Home from "./pages/Home";
import DoctorList from "./pages/DoctorList";
import DoctorForm from "./pages/DoctorForm";
import PatientList from "./pages/PatientList";
import PatientForm from "./pages/PatientForm";
import PatientVisits from "./pages/PatientVisits";
import AurikulotherapyVisits from "./components/AuriculotherapyVisits/AuriculotherapyVisits";
import EstetskaMedicineVisits from "./components/AestheticMedicineVisits/AestheticMedicineVisits";
import BodyAcupunctureVisits from "./components/BodyAcupunctureVisits/BodyAcupunctureVisits";
import VisitList from "./pages/VisitList";
import VisitForm from "./pages/VisitForm";
import NewVisitForm from "./pages/NewVisitForm";
import WaitListPage from "./pages/WaitListPage";
import PatientCarton from "./pages/PatientCarton";
import StaffManagement from "./pages/StaffManagement";
import StaffForm from "./pages/StaffForm";
import PatientManagement from "./pages/PatientManegament";
import StaffCalendar from "./pages/StaffCalendar";
import DoctorReport from "./pages/DoctorReport";
import PatientProgress from "./pages/PatientProgress";
import AcupunctureCardList from "./pages/AcupunctureCardList";
import AcupunctureCardForm from "./pages/AcupunctureCardForm";
import AcupunctureCardFormSimple from "./pages/AcupunctureCardFormSimple";
export const protectedRoutes = [
  { path: "/home", element: <Home /> },

  
  { path:"/staff" ,element: <StaffManagement /> }  ,
  { path:"/staff/new" ,element: <StaffForm />},
  {path:"/staff/edit/:id", element: <StaffForm />},
   {path:"/StaffCalendar", element: <StaffCalendar />},
  // Doctors
  { path: "/doctors", element: <DoctorList /> },
  { path: "/doctors/new", element: <DoctorForm /> },
  { path: "/doctors/:id/edit", element: <DoctorForm /> },

  // Patients
  { path: "/patients", element: <PatientList /> },
   {path:"/pacijenti" ,element: <PatientManagement /> },
  { path: "/patients/new", element: <PatientForm /> },
  { path: "/patients/:id/edit", element: <PatientForm /> },
  { path: "/patients/:id/visits", element: <PatientVisits /> },
  { path: "/patients/:patientID/aurikulotherapy", element: <AurikulotherapyVisits /> },
  { path: "/patients/:patientID/estetska-medicina", element: <EstetskaMedicineVisits /> },
  { path: "/patients/:patientID/body-acupuncture", element: <BodyAcupunctureVisits /> },
  { path: "/patient-progress/:id", element: <PatientProgress /> },
  { path: "/patients/:patientID/acupuncture-cards", element: <AcupunctureCardList /> },
  { path: "/patients/:patientID/acupuncture-cards/new", element: <AcupunctureCardForm /> },
  { path: "/acupuncture-cards/:cardID/edit", element: <AcupunctureCardForm /> },
  { path: "/patients/:patientID/acupuncture-cards/new-simple", element: <AcupunctureCardFormSimple /> },
  { path: "/acupuncture-cards/:cardID/edit-simple", element: <AcupunctureCardFormSimple /> },

  // Visits
  { path: "/visits", element: <VisitList /> },
  { path: "/visits/new", element: <VisitForm /> },
  { path: "/visits/:id/edit", element: <VisitForm /> },
  { path: "/new-visit", element: <NewVisitForm /> },
  { path: "/waitlist", element: <WaitListPage />},
  { path: "/patient-carton/:id", element: <PatientCarton />},
 { path: "/izvestaj", element: <DoctorReport />},


];
